//import { CONTACTS_DEFAULT_END, CONTACTS_DEFAULT_START } from '../conf/mtma-contacts';

export class InvitationVct {
    Token: string;
    CreatorName: string;
    CreatorEmail: string;
    Email: string;
    SiteproductId: number;
    SitemoduleId: number;
    SitefeatureId: number;
    SiteName: string;
    UVName: string;
    VEName: string;
    CreatedAt: Date;
    Accepted: Date;
    Rejected: Date;


    constructor() {
    }
}



export class CreateInvitationVct {
    Email: string;
    FirstName?: string;
    LastName?: string;
    Language?: string;
    SiteproductId?: number;
    SitemoduleId?: number;
    SitefeatureId?: number;

    constructor(email: string) {
        this.Email = email;
    }
}




export class MassiveVctInvitationsPlant {
    SitemoduleInvitations: MassiveVctInvitationsModule[];

    constructor() {
        this.SitemoduleInvitations = [];
    }
}

export class MassiveVctInvitationsModule {
    Email: string;
    SitemoduleId: number;
    FirstName?: string;
    LastName?: string;
    SitefeatureInvitations: MassiveVctInvitationsFeature[];

    constructor(email: string, moduleId: number) {
        this.Email = email;
        this.SitemoduleId = moduleId;
        this.SitefeatureInvitations = [];
    }
}

export class MassiveVctInvitationsFeature {
    Email: string;
    SitefeatureId: number;
    FirstName?: string;
    LastName?: string;

    constructor(email: string, featureId: number) {
        this.Email = email;
        this.SitefeatureId = featureId;
    }
} 